import Directory from "../../components/directory/Directory";
import { HomeContainer } from "./home.styles";
const HomePage = () => {
  return (
    <HomeContainer>
      <h1>Jimmy Cheng Photography</h1>
      <Directory />
    </HomeContainer>
  );
};

export default HomePage;
